import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './homepage';
import CheckoutSuccess from './pages/CheckoutSuccess';
import CheckoutCancel from './pages/CheckoutCancel';
import FaqPage from './pages/FaqPage';
import MetaPixelPageView from './components/MetaPixelPageView';
import './HomePage.css';

const App: React.FC = () => (
  <BrowserRouter>
    <MetaPixelPageView />
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/subscription/success" element={<CheckoutSuccess />} />
      <Route path="/subscription/cancel" element={<CheckoutCancel />} />
      <Route path="/faq" element={<FaqPage />} />
    </Routes>
  </BrowserRouter>
);

export default App;

